<template>
  <button class="button" :class="isPurple ? 'button-purple' : 'button-yellow'">
    <ThreeDotLoading v-if="loading" />
    <div v-else class="button__row">
      <img v-if="buttonIcon" :src="buttonIcon" alt="Icon" />
      <p v-if="title">{{ title }}</p>
    </div>
  </button>
</template>

<script setup>
const props = defineProps({
  title: {
    type: String,
    default: '',
  },
  buttonIcon: {
    type: String,
    default: '',
  },
  loading: {
    type: Boolean,
    default: false,
  },
  rightArrow: {
    type: Boolean,
    default: false,
  },
  isPurple: {
    type: Boolean,
    default: false,
  },
})
</script>

<style lang="scss" scoped>
.button-purple {
  background: linear-gradient(180deg, #794a98 50.48%, #653684 53.37%);
}

.button-yellow {
  background: linear-gradient(180deg, #f7ca18 50.48%, #d9ac00 53.37%);
}

.button {
  height: 66px;
  background-color: #f7ca18;
  display: grid;
  place-items: center;
  border-radius: 20px;
  width: 50%;
  font-size: 24px;
  color: #fff;
  font-weight: 900;
  border: 4px solid rgba(0, 0, 0, 0.1);
  // font-family: Croissant;

  @media screen and (max-width: 768px) {
    height: 43px;
    font-size: 22px;
    border-radius: 13px;
  }

  &__row {
    display: flex;
    align-items: center;
    gap: 10px;
    justify-content: center;
    width: 100%;

    img {
      @media screen and (max-width: 768px) {
        // width: 16px;
        height: 22px;
      }
    }

    @media screen and (max-width: 768px) {
      gap: 15px;
    }
  }
}
</style>
